import { render } from "./WithdrawPage.vue?vue&type=template&id=0405e408&scoped=true"
import script from "./WithdrawPage.vue?vue&type=script&lang=js"
export * from "./WithdrawPage.vue?vue&type=script&lang=js"

import "./WithdrawPage.vue?vue&type=style&index=0&id=0405e408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0405e408"]])

export default __exports__